const topbar = {
    docs: 'Docs',
    help: 'Aide',
    subscription: 'Abonnement',
};
export default Object.freeze(topbar);
